export default __webpack_public_path__ + "static/media/Ballroll_00155.0a323706.png";